import  CONSTANTS  from 'constants/constants.js';

const { CURRENCY, DECIMALS } = CONSTANTS;

export const getAmount = (amount, addCurrency = false) => {
  const currency = addCurrency ? CURRENCY : '';
  return `${amount.toFixed(DECIMALS)}${currency}`;
};
